<template>
  <div>
    <Logo></Logo>
    	<!-- 页头 -->
	<!-- <Header></Header> -->
    <div><img :src="image" class="bg"/></div>
    <ContactBar></ContactBar>
    <!-- 8.  Tabbar -->

    <Tabbar class="tab"></Tabbar>
  </div>
  
</template>

<script>

import Tabbar from '../Index/Index_components/Tabbar.vue'
import ContactBar from '../contact/contact_component/contactBar.vue'
// import Header from '../../common/FirstHeader.vue'
import api from '@/utils/api'
import Logo from "../Index/Index_components/logo.vue"
export default {

  name: 'contact',
  components: {
    Tabbar,
    ContactBar,
    // Header,
    Logo,
  },
  data() {
      return {
          image: '',
      }
  },
  created() {
      this.local()
  },
  methods: {
    local(){
        var storage = window.localStorage
        if (!storage){
            return false
        }else{
            if (storage.getItem('contactImage')){
                var image = JSON.parse(storage.getItem('contactImage'))
                if (image.data.code === 200){
                    this.image = image.data.data.image
                }
                if (new Date().getTime - image.time > 6500000){
                    storage.removeItem('contactImage')
                }
            }else{
                this.contact()
            }
        }
    },
    async contact(){
        const { data:data } = await api.getContactImage()
        window.localStorage.setItem('contactImage',JSON.stringify({
            time: new Date().getTime(),
            data:data
        }))
        if (data.code === 200){
            this.image = data.data.image
        }
    },
    goBack () {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/' })
        return false
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>
<style scoped>
/* .tab {
  margin-top: 23.25rem;
} */
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
</style>
